import React, { Component, Fragment } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEContainer, FHETitle, SubMenuVertical } from 'data/components';
import { SvgBox, SvgHome, SvgUser, SvgProduct, SvgJournalisation, SvgHistory } from 'data/common/iconsvg';
import { Toastr } from 'data/common';
import { HomeDetails, HomeBox, HomeUsers, HomeProducts, Journalisation, History } from './sections';
import { getSocket } from '../../common/AllSocketsMiddleware';
import { getHomeDetails } from '../../data/Homes/actions';
import selectors from './selectors';

const list = {
    details: {
        label: Translator.translate('general.home'),
        Icon: SvgHome,
        View: HomeDetails,
        right: 'homeDetails'
    },
    box: {
        firstTab: true,
        label: Translator.translate('fhe.centerName'),
        Icon: SvgBox,
        View: HomeBox,
        right: 'boxDetailsFhe'
    },
    users: {
        label: Translator.translate('general.Users'),
        Icon: SvgUser,
        View: HomeUsers,
        right: 'homeUsersFhe'
    },
    products: {
        label: Translator.translate('general.Products'),
        Icon: SvgProduct,
        View: HomeProducts,
        right: 'productsList'
    },
    history: {
        label: Translator.translate('general.history'),
        Icon: SvgHistory,
        View: History,
        right: 'homeHistoryFhe'
    },
    journalisation: {
        label: Translator.translate('general.journalisation'),
        Icon: SvgJournalisation,
        View: Journalisation,
        right: 'homeJournalisationFhe'
    }
};
class HomeDetail extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        getHomeDetails: PropTypes.func.isRequired,
        middle: PropTypes.string,
        homeLabel: PropTypes.string,
        boxId: PropTypes.number,
        boxVersion: PropTypes.string,
        boxMac: PropTypes.string,
        homeId: PropTypes.string.isRequired
    };
    static defaultProps = {
        middle: null,
        boxId: null,
        homeLabel: '',
        boxVersion: '',
        boxMac: ''
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: !props.homeLabel,
            error: null,
            tabList: this.getTabList()
        };
    }

    componentDidMount() {
        const { homeLabel } = this.props;
        this.addOnEventSocket();
        if (!homeLabel) this.getHomeDetails();
    }
    componentDidUpdate(prevProps) {
        const { middle, boxMac } = this.props;
        if (prevProps.boxMac !== boxMac || prevProps.middle !== middle) {
            this.deleteOnEventSocket(prevProps.middle, prevProps.boxMac);
            this.addOnEventSocket();
        }
    }
    componentWillUnmount() {
        const { boxMac, middle } = this.props;
        this.deleteOnEventSocket(middle, boxMac);
    }

    getHomeDetails = () => {
        const { getHomeDetails, homeId } = this.props;
        this.setState({ error: null, loading: true });
        getHomeDetails(homeId)
            .then(() => this.setState({ loading: false }))
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                this.setState({ error: message, loading: false });
            });
    };

    addOnEventSocket = () => {
        const { middle, homeId, boxMac } = this.props;
        if (middle && getSocket(middle))
            getSocket(middle)
                .on(`productStatusChange${boxMac}`, this.handleEventProductStatus)
                .on(`newProductFound${homeId}`, this.handleEventNewProductFound)
                .on(`boxStatusChange${boxMac}`, this.handleEventBoxStatus);
    };

    deleteOnEventSocket = (middle, boxMac) => {
        const { homeId } = this.props;
        if (middle && getSocket(middle))
            getSocket(middle)
                .removeListener(`productStatusChange${boxMac}`, this.handleEventProductStatus)
                .removeListener(`newProductFound${homeId}`, this.handleEventNewProductFound)
                .removeListener(`boxStatusChange${boxMac}`, this.handleEventBoxStatus);
    };

    handleEventBoxStatus = status => {
        const { history } = this.props;
        if (status)
            Toastr.success(Translator.translate(`generic.home.events.box.connected`, Translator.translate(`${history.environment}.centerName`)));
        else Toastr.error(Translator.translate(`generic.home.events.box.disconnected`, Translator.translate(`${history.environment}.centerName`)));
    };

    handleEventNewProductFound = ({ product }) => {
        const mac = product.identifier.match(/.{1,2}/g).join(':');
        const type = product.type;
        const label = product.label;

        Toastr.success(
            Translator.translate(`generic.home.events.product.connected`, label, mac),
            Translator.translate(`generic.home.events.product.new`, type),
            { onclick: this.openProductsTab }
        );
    };

    handleEventProductStatus = ({ productMac, productStatus, productLabel, displayType }) => {
        const mac = productMac.match(/.{1,2}/g).join(':');
        const type = displayType;
        if (productStatus === 'connected')
            Toastr.success(
                Translator.translate(`generic.home.events.product.connected`, productLabel, mac),
                Translator.translate(`generic.home.events.product.connectedTitle`, type),
                {
                    onclick: this.openProductsTab
                }
            );
        else if (productStatus === 'disconnected')
            Toastr.error(
                Translator.translate(`generic.home.events.product.disconnected`, productLabel, mac),
                Translator.translate(`generic.home.events.product.disconnectedTitle`, type),
                {
                    onclick: this.openProductsTab
                }
            );
    };

    openProductsTab = e => {
        this.refSubmenu.handleChange(e, list.products.key);
    };

    getTabList = () => {
        const { profile } = this.props;
        const userRights = profile.getIn(['user_rights', 'fhe'], []);
        let res = {};
        let cpt = 0;
        Object.keys(list).map(key => {
            const tab = list[key];
            if (profile.get('admin') || userRights.includes(tab.right)) {
                tab['key'] = cpt;
                res[key] = tab;
                cpt++;
            }
        });
        return res;
    };
    renderChildren = () => {
        const { tabList } = this.state;
        const { homeLabel, boxId, boxVersion, homeId, boxMac } = this.props;
        let subtitle = `HOME ID: ${homeId}`;
        if (boxId) subtitle = [`HOME ID: ${homeId}`, <br key="br" />, `BOX ID: ${boxId}`];
        return (
            <Fragment>
                <FHETitle
                    title={homeLabel}
                    subTitle={subtitle}
                    suffixTitle={`${Translator.translate('fhe.centerName')} (Mac: ${
                        boxMac ? boxMac.match(/.{1,2}/g).join(':') : ''
                    }, Version: ${boxVersion})`}
                    Icon={SvgHome}
                />
                <SubMenuVertical tabList={tabList} childRef={ref => (this.refSubmenu = ref)} />
            </Fragment>
        );
    };
    render() {
        const { error, loading } = this.state;
        const { classes } = this.props;

        return (
            <FHEContainer
                withBackIcon
                classContainer={classes.classContainer}
                loading={loading}
                error={error}
                onClickFunc={this.getHomeDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const homeId = props.match.params.homeId;
    const home = selectors.getHomeByHomeId(state, homeId);
    const homeBox = selectors.getBoxByHomeId(state, homeId);

    return {
        profile: selectors.getProfile(state),
        homeId,
        middle: homeBox.get('middleware'),
        homeLabel: home.get('label'),
        boxId: homeBox.get('boxId'),
        boxVersion: homeBox.get('firmwareVersion'),
        boxMac: homeBox.get('macAddress')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    classContainer: {
        width: 'auto',
        [theme.breakpoints.down('md')]: {
            marginLeft: 50
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: 30
        }
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getHomeDetails }, dispatch)
    )(withStyles(styles, { withTheme: true })(HomeDetail))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/details.js